import { useCallback, useState } from 'react';
import type { PermissionsMap } from 'vopay';
import { useApi } from '#shared/providers/Api';
import useUsers from '../useUsers';
import unwrap from '../unwrap';

// The categorized permission catalog a role is built from, with every permission reset to off, so the drawer starts with nothing selected. Rejects on failure.
export default function useRolePermissionsCatalog() {
  const api = useApi();
  const { viewer } = useUsers();
  const [catalog, setCatalog] = useState<PermissionsMap>({});
  const [isFetching, setIsFetching] = useState(false);

  const fetchCatalog = useCallback(async () => {
    try {
      setIsFetching(true);

      // Deliberately unscoped by account.bearer: the role catalog comes from the logged-in user's own
      // account permissions, even when the page is scoped to a sub-account.
      const fetched = (await unwrap(api.fetchAccountUserPermissionsNew({ EmailAddress: viewer.username }))).Permissions;
      const blankCatalog: PermissionsMap = {};

      Object.entries(fetched).forEach(([groupName, group]) => {
        blankCatalog[groupName] = {};

        Object.entries(group).forEach(([permissionKey, item]) => {
          blankCatalog[groupName][permissionKey] = { label: item.label, tooltip: item.tooltip, permitted: false };
        });
      });

      setCatalog(blankCatalog);
    } finally {
      setIsFetching(false);
    }
  }, [api, viewer.username]);

  return { catalog, isFetching, fetchCatalog };
}
